export function getGrommet3StepNums({ t, step3A0, step3A, step3B }) {
  let wallSillStepNum3;
  let floorStepNum3;
  let standardCeilingSillStepNum3;
  let standardCeilingFloorStepNum3;
  let wallFloorStepNum3;
  let wallExtensionStepNum3;

  if (step3A === "Wall to Wall") {
    wallSillStepNum3 = t("4D");
  } else if (
    step3A0 === "Wall" &&
    step3A === "Standard" &&
    (step3B === "Sill" || step3B === "Apron")
  ) {
    wallSillStepNum3 = t("4E");
  } else if (
    step3A0 === "Wall" &&
    (step3A === "Left Corner Window" || step3A === "Right Corner Window") &&
    (step3B === "Sill" || step3B === "Apron")
  ) {
    wallSillStepNum3 = t("4E");
  } else {
    wallSillStepNum3 = t("4F");
  }

  if (step3A === "Wall to Wall") {
    floorStepNum3 = t("4D");
  } else {
    floorStepNum3 = t("4E");
  }

  if ((step3A0 === "Ceiling" || step3A0 === "Moulding") && step3A === "Wall to Wall" && (step3B === "Sill" || step3B === "Apron")) {
    standardCeilingSillStepNum3 = t("4D");
  } else if (step3A0 === "Ceiling" && (step3A === "Left Corner Window" || step3A === "Right Corner Window") && (step3B === "Sill" || step3B === "Apron")) {
    standardCeilingSillStepNum3 = t("4E");
  } else if (step3A === "Wall to Wall") {
    standardCeilingSillStepNum3 = t("4E");
  }else if (step3A0 === "Ceiling" && step3A === "Standard") {
    standardCeilingSillStepNum3 = t("4E");
  } else if (step3A0 === "Moulding" && (step3A === "Standard" || step3A === "Left Corner Window" || step3A === "Right Corner Window")) {
    standardCeilingSillStepNum3 = t("4E");
  }  else {
    standardCeilingSillStepNum3 = t("4F");
  }

  if (step3A === "Wall to Wall") {
    if(step3A === "Wall to Wall" && (step3A0 === "Ceiling" || step3A0 === "Moulding") ) {
      standardCeilingFloorStepNum3 = t("4D");
    } else {
      standardCeilingFloorStepNum3 = t("4E");
    }
   } else if (step3A0 === "Ceiling" && step3A === "Standard") {
    standardCeilingFloorStepNum3 = t("4E");
  } else if (step3A0 === "Ceiling" && (step3A === "Left Corner Window" || step3A === "Right Corner Window")) {
    standardCeilingFloorStepNum3 = t("4E");
  } else if (step3A0 === "Moulding"  && (step3A === "Standard" || step3A === "Left Corner Window" || step3A === "Right Corner Window")) {
    standardCeilingFloorStepNum3 = t("4E");
  } else {
    standardCeilingFloorStepNum3 = t("4F");
  }

  if (step3A === "Wall to Wall") {
    wallFloorStepNum3 = t("4E");
  } else {
    wallFloorStepNum3 = t("4F");
  }

  if (step3A0 !== "Wall") {
    if (step3A === "Wall to Wall") {
      if ((step3A0 === "Ceiling" || step3A0 === "Moulding") && step3A === "Wall to Wall" && (step3B === "Sill" || step3B === "Apron")) {
        wallExtensionStepNum3 = t("4E");
      } else {
        wallExtensionStepNum3 = t("4F");
      }
    } else {
      if ((step3A0 === "Ceiling" || step3A0 === "Moulding") && (step3A === "Standard" || step3A === "Left Corner Window" || step3A === "Right Corner Window") && (step3B === "Sill" || step3B === "Apron")) {
        wallExtensionStepNum3 = t("4F");
      } else {
        wallExtensionStepNum3 = t("4G");
      }
      
    }
  } else if (step3A === "Wall to Wall") {
    wallExtensionStepNum3 = t("4F");
  } else {
    wallExtensionStepNum3 = t("4G");
  }

  return {
    wallSillStepNum3,
    floorStepNum3,
    standardCeilingSillStepNum3,
    standardCeilingFloorStepNum3,
    wallFloorStepNum3,
    wallExtensionStepNum3,
  };
}
